import { useEffect } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";
import Constants from "../data/constants";
import { PaymentSourceTypes } from "@brushfire/types";
import { SESSION_STORAGE_KEYS, getFromSessionStorage, setInSessionStorage, removeFromSessionStorage } from "../data/sessionStorageHelpers";
var paths = [
    Constants.Routes.eventList,
    Constants.Routes.calendar,
    Constants.Routes.eventStart,
];
export var useSpecificBFPayment = function (paymentMethods) {
    var _a, _b, _c, _d;
    if (paymentMethods === void 0) { paymentMethods = []; }
    var bfPayment = getFromSessionStorage(SESSION_STORAGE_KEYS.BF_PAYMENT);
    var paymentSourceTypes = (_a = bfPayment === null || bfPayment === void 0 ? void 0 : bfPayment.split(',').filter(function (pay) { return pay.toUpperCase() in PaymentSourceTypes; }).map(function (type) { return PaymentSourceTypes[type.toUpperCase()]; })) !== null && _a !== void 0 ? _a : [];
    var customPaymentMethodIds = (_b = bfPayment === null || bfPayment === void 0 ? void 0 : bfPayment.split(',').filter(function (pay) { return !(pay.toUpperCase() in PaymentSourceTypes) && paymentMethods.some(function (method) { var _a; return ((_a = method.paymentMethodId) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === pay.toUpperCase(); }); })) !== null && _b !== void 0 ? _b : [];
    var path = useRouteMatch().path;
    var search = useLocation().search;
    var paymentParam = (_c = new URLSearchParams(search).get("payment")) !== null && _c !== void 0 ? _c : "";
    var bfPaymentInvalid = !bfPayment || (paymentSourceTypes.length === 0 && customPaymentMethodIds.length === 0);
    var bfPaymentAllowsWalletOrAfterpay = bfPaymentInvalid || [
        PaymentSourceTypes.APPLE_PAY,
        PaymentSourceTypes.GOOGLE_PAY,
        PaymentSourceTypes.BUY_NOW_PAY_LATER
    ].some(function (type) { return paymentSourceTypes.includes(type); });
    var bfPaymentAllowsCheckout = bfPaymentInvalid || [
        PaymentSourceTypes.CARD,
        PaymentSourceTypes.GIFT_CARD,
        PaymentSourceTypes.BANK_ACCOUNT,
        PaymentSourceTypes.CASH_APP,
    ].some(function (type) { return paymentSourceTypes.includes(type); }) || ((_d = customPaymentMethodIds.length) !== null && _d !== void 0 ? _d : 0) > 0;
    useEffect(function () {
        if (paymentParam && path && paths.includes(path)) {
            setInSessionStorage(SESSION_STORAGE_KEYS.BF_PAYMENT, paymentParam);
        }
    }, [paymentParam, path]);
    var removeSpecificBFPayment = function () {
        removeFromSessionStorage(SESSION_STORAGE_KEYS.BF_PAYMENT);
    };
    return {
        paymentSourceTypes: paymentSourceTypes,
        customPaymentMethodIds: customPaymentMethodIds,
        bfPaymentAllowsWalletOrAfterpay: bfPaymentAllowsWalletOrAfterpay,
        bfPaymentAllowsCheckout: bfPaymentAllowsCheckout,
        bfPaymentInvalid: bfPaymentInvalid,
        removeSpecificBFPayment: removeSpecificBFPayment,
    };
};
